window.addEventListener('load', () => {
  const productList = document.querySelectorAll('.miscellaneous_prod ul li');

  productList.forEach( productCard => {
    const dropdownSelector = productCard.querySelector('.miscellaneous_select');
    let variantList = false,
        productPriceElement = false,
        productComparePriceElement = false;

    if (dropdownSelector !== null) {
      variantList = dropdownSelector.querySelectorAll('option'),
      productPriceElement = productCard.querySelector('.mutable-product-price'),
      productComparePriceElement = productCard.querySelector('.mutable-compare-price');
    }
    
    if (variantList && productPriceElement) {
    
      appendPriceDiffToDropdownOptions();
      changePriceOnVariantSelect();

      function appendPriceDiffToDropdownOptions(){
        variantList.forEach( variantOption => {
          const variantPrice = variantOption.dataset.variantPrice;
          const priceDifference = variantPrice - dropdownSelector.dataset.lowestProductPrice;

          if (priceDifference > 0) {
            variantOption.innerHTML += ` +$${priceDifference % 100 === 0 ? priceDifference / 100 : (priceDifference / 100).toFixed(2)}`;
          }
        })
      }

      function changePriceOnVariantSelect(){ 
        dropdownSelector.addEventListener( 'change', dropdownEl => {
          const selectedVariantPrice = dropdownEl.target.selectedOptions[0].dataset.variantPrice / 100;
          productPriceElement.innerHTML = `$${selectedVariantPrice.toFixed(2)}`;

          if (productComparePriceElement) {
            const selectedVariantCompareAtPrice = dropdownEl.target.selectedOptions[0].dataset.variantCompareAtPrice / 100;
            if (selectedVariantCompareAtPrice > 0) {
              productComparePriceElement.innerHTML = `$${selectedVariantCompareAtPrice.toFixed(2)}`;
            }
          }
        })
      }

    }
  })
})
